import type { StorageLocationsEntity } from '~/domain/Insurance/storageLocationsEntity';
import type { StorageLocationQuestionResponseDTO } from '~/dto/Insurance/storageLocationQuestionDTO';

export const storageLocationsResponseMapper = ({
  resultData,
}: StorageLocationQuestionResponseDTO): StorageLocationsEntity => {
  if (resultData.length) {
    const initialValue: StorageLocationsEntity['storageLocations'] = {};
    const storageLocations = resultData.reduce<
      StorageLocationsEntity['storageLocations']
    >((obj, item) => {
      return {
        ...obj,
        [item.id]: {
          question: item.pergunta,
          answers: item.respostas.map((option) => ({
            label: option.descricao,
            value: option.id.toString(),
          })),
        },
      };
    }, initialValue);
    return { success: true, storageLocations };
  }
  return { success: false, storageLocations: {} };
};
